import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

function normalizarTel(tel?: string | null): string | null {
  if (!tel) return null;
  const d = tel.replace(/\D/g, '');
  if (d.length === 10 || d.length === 11) return '55' + d;
  if (d.length === 12 || d.length === 13) return d;
  return null;
}

export function useOperadoraTelefone(telefone?: string | null) {
  const tel55 = normalizarTel(telefone);
  return useQuery({
    queryKey: ['operadora-telefone', tel55],
    enabled: !!tel55,
    staleTime: 1000 * 60 * 60,
    queryFn: async () => {
      if (!tel55) return null;
      const { data } = await supabase
        .from('telefones_operadora')
        .select('operadora')
        .eq('telefone', tel55)
        .maybeSingle();
      return (data?.operadora as string) || null;
    },
  });
}
